import { Box } from "@mui/material";
import type { PropsWithChildren } from "react";

import AppDrawer from "./AppDrawer/AppDrawer";
import { ContentLayout } from "./ContentLayout";
import GaiaTopMenu from "./GaiaTopMenu";

/** The app shell: topbar + sidebar + page content. */
export default function LayoutContainer({ children }: PropsWithChildren<unknown>) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100dvh", overflow: "hidden" }}>
            <GaiaTopMenu />
            <AppDrawer>
                <ContentLayout>{children}</ContentLayout>
            </AppDrawer>
        </Box>
    );
}
